import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

import BlockHeader from '@/components/display/blocks/block-header';

type Block = {
    title: string;
    content: string | JSX.Element | React.ReactNode;
};

type DescriptiveGridProps = {
    className?: string;
    blockTitleClassName?: string;
    title: string;
    subTitle?: string;
    blocks: Block[];
};

const DescriptiveGrid = (props: DescriptiveGridProps) => {
    const { title, blocks, subTitle, className, blockTitleClassName } = props;

    return (
        <section
            className={cn(
                'flex flex-col justify-center items-center gap-10 px-4 md:px-8 lg:px-12 xl:px-24 py-20 border-t border-b',
                className,
            )}
        >
            <BlockHeader title={title} subTitle={subTitle} />
            <div className="flex flex-wrap lg:flex-nowrap flex-row justify-start items-start self-stretch gap-5">
                <>
                    {blocks.map((block, idx) => (
                        <div
                            key={idx}
                            className="flex flex-col justify-start items-start flex-grow relative gap-1 p-10 border border-[#b4b4b4]/[0.35]"
                        >
                            <p className={cn('w-full whitespace-nowrap text-xl', blockTitleClassName)}>{block.title}</p>
                            <>{block.content}</>
                        </div>
                    ))}
                </>
            </div>
        </section>
    );
};

export default DescriptiveGrid;
